module.exports = __webpack_public_path__ + "static/media/profile.072ef68c.jpg";